module.exports = __webpack_public_path__ + "img/capture.bc391b92.svg";